import React, { Fragment, PureComponent } from 'react';
import { Country } from '~/Api/Country';
import { Product as GeneralProduct } from '~/Api/Product';
import { Item } from '~/Api/User/ProductGroup/AeMaxPrice';
import { ProductPrice } from '~/Product';

import Header from './Header/Header';
import Row, { EmptyRow, OnChangeListener, OnSelectListener, Values } from './Row';

export interface ProductRow {
	country: Country | null;
	item: Item | null;
	price: ProductPrice | null;
}

export type ProductValues = Values;

interface Props {
	products: ProductRow[];
	productValues: { [key in string]: Values };
	detailLink(product: { id: string }): { pathname: string; search: string };
	highlightProductId: string | null;
	lastSelectedProductId: string | null;
	disableSelection: boolean;
	onChange: OnChangeListener;
	onSelect: OnSelectListener;
	onSave(): void;
	checkedRows: GeneralProduct[];
	checkRow(product: GeneralProduct, checked: boolean): void;
}

export default class ProductsTable extends PureComponent<Props> {
	static defaultProps = {
		highlightProductId: null,
		lastSelectedProductId: null,
		disableSelection: false,
	};

	render() {
		const { products } = this.props;

		return (
			<Fragment>
				<Header />
				{products.map((optionalProduct) => {
					const { country, item, price } = optionalProduct;
					return item ? this.renderRow(item, price) : <EmptyRow country={country} key={country?.alpha2 || ''} />;
				})}
			</Fragment>
		);
	}

	renderRow(item: Item, price: ProductPrice | null) {
		const {
			productValues,
			disableSelection,
			highlightProductId,
			lastSelectedProductId,
			detailLink,
			onChange,
			onSelect,
			onSave,
			checkRow,
		} = this.props;
		const { product } = item;
		const checked = this.props.checkedRows?.some((row) => row.id === product.id);

		return (
			<Row
				detailLink={detailLink}
				disableSelection={disableSelection}
				highlightProduct={highlightProductId === product.id}
				checked={checked}
				checkRow={(value) => checkRow(product, value)}
				item={item}
				key={product.id}
				lastSelectedProduct={lastSelectedProductId === product.id}
				price={price}
				values={productValues[product.id]}
				onChange={onChange}
				onSave={onSave}
				onSelect={onSelect}
			/>
		);
	}
}
